export default {
    donationCategoryListWithChildren: []
}